<div class="mat-elevation-z5">
    <mat-toolbar color="primary">
      <mat-icon svgIcon="alert-outline"></mat-icon>
      <h1 class="mat-title">Pagina verlaten?</h1>
    </mat-toolbar>
  <div class="mat-body">
    Deze pagina bevat nog niet opgeslagen gegevens.<br/>
    Als u deze pagina verlaat worden deze gegevens niet opgeslagen.
  </div>
  <div class="uf-action-row">
    <button mat-button mat-raised-button (click)="onLeave()">Pagina verlaten</button>
    <button mat-button mat-raised-button class="mat-primary" (click)="onStay()">Op deze pagina blijven</button>
  </div>
</div>
